module.exports=function(scope){ return `// Configure the FaceTec SDK Strings
// @param - ZoomLocalizationStrings: {[key: string]: string}
// ZoomLocalizationStrings is JSON defined in ZoomStrings.js sample file
ZoomSDK.configureLocalization(ZoomLocalizationStrings);
`};


// WEBPACK FOOTER //
// ./src/resources/code/web/quickstart/localization-call-api.js.tpl